import { ReactNode } from "react"

interface Props {
    children?: ReactNode
}

export function Table({ children }: Props) {
    return (
        <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <table className="min-w-full divide-y divide-gray-300 dark:divide-zinc-700">{children}</table>
                </div>
            </div>
        </div>
    )
}
